import {Injectable} from '@angular/core';
import {InactiveLicensesInformation} from './inactive-licenses-information.model';
import {Service} from '../../common/service.class';
import {UserModelService} from '../../common/user-model.service';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class InactiveLicensesInformationService extends UserModelService<InactiveLicensesInformation> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'inactiveLicensesInformation', InactiveLicensesInformation);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/inactive/inactive-licenses-information.service.ts